module.exports = __webpack_public_path__ + "static/NK-ed1de55dd0c23d1d637e88f5e3b79f52.jpg";